const formatResultDate = (dateString) => {
  const date = new Date(dateString);
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${month}/${day}, ${String(hours).padStart(
    2,
    "0"
  )}:${minutes} ${ampm}`;
};

function resultCardImg(code) {
  return `/assets/images/cards/${code && code !== "1" ? code : "1"
    }.svg`;
}

function getCardValue(card) {
  if (!card) return null;

  const value = String(card).slice(0, -2);

  if (value === "A") return 1;
  if (value === "J") return 11;
  if (value === "Q") return 12;
  if (value === "K") return 13;

  return Number(value);
}


function getCardSuit(card) {
  if (!card) return "";
  return String(card).slice(-2);
}

function getCardColor(card) {
  if (!card) return "";
  const suit = getCardSuit(card);
  if (suit === "HH" || suit === "DD") { return "Red"; }
  if (suit === "CC" || suit === "SS") { return "Black"; }
  return "";
}


function isOdd(card) {
  const value = getCardValue(card);
  if (value === null || Number.isNaN(value)) {
    return false;
  }
  return value % 2 !== 0;
}

function isEven(card) {
  const value = getCardValue(card);
  if (value === null || Number.isNaN(value)) {
    return false;
  }
  return value % 2 === 0;
}

function getSuitName(card) {
  const suit = getCardSuit(card);
  if (suit === "HH") return "Hearts";
  if (suit === "DD") return "Diamonds";
  if (suit === "CC") return "Clubs";
  if (suit === "SS") return "Spades";
  return "";
}


const DtResult = ({ resultData = [] }) => {
  return (
    <div id="ResultsData" className="tabcontent" style={{ display: "block" }}  >
      <div className="left-content">
        {resultData?.length > 0 &&
          resultData.map((dataObj, index) => {

            const dragonCard = dataObj.c1;
            const tigerCard = dataObj.c2;
            const resultText = dataObj?.resultTxt || "";

            const isWinner = (marketName) => {
              return resultText
                .split(",")
                .map((item) => item.trim())
                .includes(marketName);
            };

            const dragonWinner =
              dataObj.result === "1" ||
              dataObj.result === 1;

            const tigerWinner =
              dataObj.result === "2" ||
              dataObj.result === 2;

            const markets = [
              {
                label: "Dragon",
                card: dragonCard,
                main: true,
                winner: dragonWinner
              },

              {
                label: "Tiger",
                card: tigerCard,
                main: true,
                winner: tigerWinner
              },
              {
                label: "Dragon-Odd",
                winner: isWinner("Dragon - Odd")
              },

              {
                label: "Dragon-Even",
                winner: isWinner("Dragon - Even")
              },

              {
                label: "Tiger-Odd",
                winner: isWinner("Tiger - Odd")
              },

              {
                label: "Tiger-Even",
                winner: isWinner("Tiger - Even")
              },
              {
                label: "Dragon-Black",
                winner: isWinner("Dragon - Black")
              },

              {
                label: "Dragon-Red",
                winner: isWinner("Dragon - Red")
              },

              {
                label: "Tiger-Black",
                winner: isWinner("Tiger - Black")
              },

              {
                label: "Tiger-Red",
                winner: isWinner("Tiger - Red")
              },


              // =========================
              // SUITS
              // =========================

              {
                label: "Dragon-Hearts",
                winner: isWinner("Dragon - Hearts")
              },

              {
                label: "Dragon-Spades",
                winner: isWinner("Dragon - Spades")
              },

              {
                label: "Dragon-Clubs",
                winner: isWinner("Dragon - Clubs")
              },

              {
                label: "Dragon-Diamonds",
                winner: isWinner("Dragon - Diamonds")
              },

              {
                label: "Tiger-Hearts",
                winner: isWinner("Tiger - Hearts")
              },

              {
                label: "Tiger-Spades",
                winner: isWinner("Tiger - Spades")
              },

              {
                label: "Tiger-Clubs",
                winner: isWinner("Tiger - Clubs")
              },

              {
                label: "Tiger-Diamonds",
                winner: isWinner("Tiger - Diamonds")
              }
            ];
            return (
              <div
                key={index}
                className="card"
                style={{
                  border: "1px solid rgb(204, 204, 204)",
                  borderRadius: "8px",
                  boxShadow:
                    "rgba(0, 0, 0, 0.1) 0px 4px 8px",
                  marginBottom: "5px",
                  background:
                    "linear-gradient(rgb(15, 15, 15), rgb(251, 251, 251))",
                  color: "white"
                }}
              >
                <div
                  className="card-header"
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "10px",
                    marginTop: "10px",
                    marginLeft: "10px",
                    background: "transparent",
                    borderBottom: "solid 1px #000"
                  }}
                >
                  {formatResultDate(dataObj.evt_od)} -{" "} <b>ID=</b> {dataObj._id}
                </div>
                <div className="card-body">
                  <div className="players-table" style={{ textAlign: "center", width: "100%" }} >
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <tbody>
                        <tr
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-evenly",
                            background: "transparent"
                          }}
                        >
                          {markets.map((market) => {
                            if (market.main) {
                              return (
                                <td key={market.label} className="TdResults" >
                                  <div
                                    className="player-cards"
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                      overflowWrap: "break-word"
                                    }}
                                  >
                                    <div
                                      className="player-name"
                                      style={{
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        width: "100%"
                                      }}
                                    >
                                      {market.label}
                                    </div>
                                    <div
                                      className="card-images"
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        gap: "3px",
                                        flexWrap: "wrap",
                                        width: "100%"
                                      }}
                                    >
                                      {market.card ? (
                                        <img src={resultCardImg(market.card)} loading="lazy" alt=""
                                          style={{
                                            width: "40px",
                                            height: "60px",
                                            objectFit: "cover",
                                            borderRadius: "5px"
                                          }} />
                                      ) : (
                                        <div style={{ width: "40px", height: "60px" }} />
                                      )}
                                    </div>
                                    <div
                                      className={
                                        market.winner
                                          ? "player-status bgwinner"
                                          : "player-status bgLoser"
                                      }
                                      style={{
                                        background: market.winner
                                          ? "#cf8d2e"
                                          : "#cf3f3f",
                                        color: "#000",
                                        marginTop: "10px",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        textAlign: "center",
                                        width: "100%"
                                      }}
                                    >
                                      {market.winner ? "WINNER" : "LOSER"}
                                    </div>
                                  </div>
                                </td>
                              );
                            }
                            if (!market.winner) { return null; }
                            return (
                              <td key={market.label} className="TdResults TdResultsWin" >
                                <div
                                  className="player-cards"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    overflowWrap: "break-word",
                                    background: "green",
                                    borderRadius: "10px",
                                    overflow: "hidden"
                                  }}
                                >
                                  <div
                                    className="player-name"
                                    style={{
                                      fontWeight: "bold",
                                      textAlign: "center",
                                      width: "100%",
                                      color: "#fff"
                                    }}
                                  >
                                    {market.label}
                                  </div>
                                  <div
                                    className="card-images"
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      minHeight: "65px",
                                      width: "100%"
                                    }}
                                  >
                                    <img src="/assets/images/cards/1.svg" alt="" style={{ width: "45px" }} />
                                  </div>
                                  <div
                                    className="player-status bgwinner"
                                    style={{
                                      background: "#cf8d2e",
                                      color: "#000",
                                      marginTop: "5px",
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      textAlign: "center",
                                      width: "100%"
                                    }}
                                  >
                                    WINNER
                                  </div>
                                </div>
                              </td>
                            );
                          })}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};


export default DtResult;